import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92894 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121 8.17317C3.51809 6.3459 4.79981 4.78412 6.4443 3.6853ZM10.17 16.28L16 12.64C16.1074 12.5712 16.1957 12.4766 16.2569 12.3648C16.3181 12.2529 16.3501 12.1275 16.3501 12C16.3501 11.8725 16.3181 11.7471 16.2569 11.6352C16.1957 11.5234 16.1074 11.4288 16 11.36L10.15 7.72C10.0369 7.64866 9.9067 7.60888 9.77301 7.60477C9.63931 7.60067 9.50696 7.63239 9.38965 7.69666C9.27234 7.76092 9.17436 7.85538 9.10585 7.97026C9.03734 8.08514 9.00079 8.21625 9 8.35V15.65C8.99842 15.7869 9.03434 15.9216 9.10386 16.0395C9.17338 16.1575 9.27385 16.2541 9.39438 16.319C9.51491 16.3839 9.65091 16.4146 9.78764 16.4077C9.92436 16.4008 10.0566 16.3567 10.17 16.28Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgPlayCircle = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPlayCircle;
